define("shared/utils/analytics/generate-cache-key", ["exports", "shared/utils/hash-code"], function (_exports, _hashCode) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = generateCacheKey;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/hash-code"eaimeta@70e063a35619d71f

  /**
   * Returns a string with a prefix and unique hashed value to be used for caching. To be used with api endpoints.
   *
   * @method _generateCacheKey
   * @param {String} prefix start of string that is to be used for lookup from cache
   * @param {Object} cacheParams
   * @param {String} cacheParams.[dateKey=null] key generated from start and end dates of data set
   * @param {String} cacheParams.[type="data"] type of data to be cached
   * @param {String} cacheParams.endpoint API endpoint to be cached
   * @param {Number} cacheParams.socialProfileId unique id of social profile to be cached
   * @param {String} cacheParams.cursor cursor value
   * @param {String} cacheParams.[mediaId=null]
  
   * @returns {String}
   */
  function generateCacheKey(prefix, _ref) {
    let {
      dateKey = null,
      type = 'data',
      endpoint,
      mediaId = null,
      socialProfileId,
      cursor = null
    } = _ref;
    return "".concat(prefix, "_").concat((0, _hashCode.default)(JSON.stringify({
      dataType: type,
      dateKey,
      endpoint,
      mediaId,
      socialProfileId,
      cursor
    })));
  }
});